import { useId } from 'react';
import type { DashboardHeroProps } from './types';

const accentClasses = {
  gold: 'border-l-club-gold-400',
  coach: 'border-l-club-blue-400',
  medical: 'border-l-success-400',
  scout: 'border-l-warning-400',
} as const;

export default function DashboardHero({
  title,
  supportingText,
  accent = 'gold',
  primaryValue,
  primaryLabel,
  action,
}: DashboardHeroProps) {
  const titleId = useId();

  return (
    <section
      aria-labelledby={titleId}
      className={`min-w-0 rounded-2xl border-l-[5px] bg-club-navy-950 p-5 text-white shadow-sm dark:bg-club-navy-950 sm:p-6 ${accentClasses[accent]}`}
    >
      <div className="flex min-w-0 flex-col gap-5 sm:flex-row sm:items-end sm:justify-between">
        <div className="min-w-0">
          <h1 id={titleId} className="break-words text-2xl font-bold tracking-tight sm:text-3xl">
            {title}
          </h1>
          <p className="mt-2 max-w-2xl break-words text-sm text-club-navy-100 sm:text-base">{supportingText}</p>
        </div>
        {(primaryValue !== undefined || primaryLabel || action) && (
          <div className="flex min-w-0 flex-wrap items-end gap-4 sm:justify-end">
            {(primaryValue !== undefined || primaryLabel) && (
              <div className="min-w-0">
                {primaryValue !== undefined && <p className="break-words text-3xl font-semibold tabular-nums">{primaryValue}</p>}
                {primaryLabel && <p className="mt-1 break-words text-xs font-medium uppercase tracking-wide text-club-navy-100">{primaryLabel}</p>}
              </div>
            )}
            {action && <div className="min-w-0">{action}</div>}
          </div>
        )}
      </div>
    </section>
  );
}
